<div class="ion-page" style="overflow-y: hidden !important ;">
  <ion-header>
    <ion-toolbar style="text-align: center;" color="secondary">
      <ion-title class="modal-title">
        <ion-icon name="business-outline" class="title-icon"></ion-icon>
        {{group ? group.Name : (configuration?.BusinessUnitName ? ('New ' | translate) + (configuration.BusinessUnitName | translate) : ('New group' | translate))}}
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content color="secondary">
    <form [formGroup]="groupForm" class="modal-form">

      <!-- Name field -->
      <div class="field-group">
        <ion-label class="field-label" [class.required]="groupForm.get('Name')?.hasError('required')">
          {{'Name' | translate}}
        </ion-label>
        <ion-item class="field-item" lines="full">
          <ion-input type="text" formControlName="Name" autocomplete="off"
          placeholder="{{configuration?.BusinessUnitName ? (configuration.BusinessUnitName | translate) + (' name' | translate) : ('Group name' | translate)}}"></ion-input>
        </ion-item>
        @if (groupForm.get('Name')?.errors && groupFormSubmitted) {
          <div class="field-error">
            <ion-icon name="alert-circle-outline"></ion-icon>
            @if (groupForm.get('Name')?.hasError('required')) {
              <ion-text>{{ 'Mandatory field' | translate }}</ion-text>
            }
          </div>
        }
      </div>

      <!-- Collapsable toggle -->
      <div class="field-group">
        <ion-item class="toggle-item" lines="none">
          <ion-icon name="git-network-outline" slot="start" class="toggle-icon"></ion-icon>
          <ion-label>{{ 'Group by' | translate }}</ion-label>
          <ion-toggle formControlName="Collapsable" (ionChange)="onCollapsableChange()" slot="end">
            <span style="display:none">{{ 'Group by' | translate }}</span>
          </ion-toggle>
        </ion-item>
      </div>

      <!-- Collapsable title -->
      @if (isCollapsable) {
        <div class="field-group collapsable-section">
          <ion-label class="field-label" [class.required]="groupForm.get('CollapsableTitle')?.hasError('required') && groupFormSubmitted">{{ 'Group by title' | translate }}</ion-label>
          <ion-item class="field-item" lines="full">
            @if(availableCollapsableTitles?.length > 0) {
              <ion-select aria-label="Group by titles" interface="popover"
                placeholder="{{ 'Select title' | translate }}"
                formControlName="CollapsableTitle"
                (ionChange)="handleChange($event)">
                @for (title of availableCollapsableTitles; track title) {
                  <ion-select-option [value]="title.Title">{{title.Title}}</ion-select-option>
                }
              </ion-select>
            } @else {
              <ion-label class="empty-label">{{ 'No titles available' | translate }}</ion-label>
            }
            <ion-button size="small" slot="end"  (click)="addNewCollapsableTitle()" color="tertiary" class="add-btn">
              <ion-icon name="add-outline" slot="start"></ion-icon>
              <label>{{'Add new' | translate}}</label>
            </ion-button>
          </ion-item>
          @if (groupForm.get('CollapsableTitle')?.errors && groupFormSubmitted) {
            <div class="field-error">
              <ion-icon name="alert-circle-outline"></ion-icon>
              @if (groupForm.get('CollapsableTitle')?.hasError('required')) {
                <ion-text>{{ 'Mandatory field' | translate }}</ion-text>
              }
            </div>
          }
        </div>
      }

    </form>
  </ion-content>

  <div style="position: absolute; bottom: 0; left: 0; right: 0; padding: 0 8px 8px; background: var(--ion-color-secondary);">

    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button color="tertiary" expand="block" (click)="onBack()">{{ 'Cancel' | translate }}</ion-button>
        </ion-col>
        <ion-col>
          <ion-button color="medium" expand="block" (click)="saveGroup()" type="submit" [disabled]="groupFormProcessing">
            @if (groupFormProcessing) {
              <ion-spinner name="dots" slot="start"></ion-spinner>
            }
            {{group ? ('Save' | translate) : ('Create' | translate)}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
